if(!customElements.get('fit-add-to-cart')) {
    class FitAddToCart extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.selectors = {
                button: this.querySelector('.add-to-cart')
            }
            if (!this.selectors.button) {
                return;
            }
            this.selectors.button.addEventListener('click', (e) => this._onClick(e));
        }

        _onClick(e) {
            const button = e.target.closest('.add-to-cart');
            if (!button) {
                return;
            }

            // 1) Fit "buy dialog" flow (goggles that require a scan). The dialog
            //    handles variant selection and adding to cart itself.
            if (button.dataset.enabledDialog === 'true') {
                e.preventDefault();
                // Stop the click from bubbling to the theme's delegated
                // [data-action="add-to-cart"] handler (main-product section),
                // which would otherwise add the default variant in parallel.
                e.stopPropagation();
                const event = new CustomEvent("fitBuyDialog", {
                    detail: { productHandle: button.dataset.productHandle, mode: 'direct' }
                });
                document.dispatchEvent(event);
                return;
            }

            // This section is not registered as a theme "product" section, so the
            // theme's ProductVariants add-to-cart handler never runs here. We
            // therefore drive add-to-cart ourselves.

            // 2) Drawer stores: add via AJAX and let the cart drawer open.
            if (button.dataset.ajaxCart === 'true') {
                e.preventDefault();
                this._ajaxAddToCart(button);
                return;
            }

            // 3) Page stores: let the product <form> submit natively, which posts
            //    to /cart/add and redirects to the cart page (the button is
            //    rendered as type="submit" in this case).
        }

        _ajaxAddToCart(button) {
            const form = button.closest('form');
            if (!form || button.hasAttribute('disabled')) {
                return;
            }

            button.setAttribute('disabled', 'disabled');
            document.dispatchEvent(new CustomEvent('theme:loading:start'));

            fetch(`${window.routes.cartAddUrl}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: new FormData(form)
            }).then((response) => {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                button.removeAttribute('disabled');

                if (response.ok) {
                    const quantityField = form.querySelector('[name="quantity"]');
                    // The theme's CartSection listens for this and re-renders /
                    // opens the mini-cart drawer.
                    document.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            quantity: quantityField ? parseInt(quantityField.value, 10) || 1 : 1
                        }
                    }));
                    return;
                }

                response.json().then((content) => {
                    this._showError(button, (content && content.description) || 'Could not add to cart.');
                }).catch(() => this._showError(button, 'Could not add to cart.'));
            }).catch(() => {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                button.removeAttribute('disabled');
                this._showError(button, 'Could not add to cart.');
            });
        }

        _showError(button, message) {
            const host = button.parentNode;
            const existing = host.querySelector('.ProductForm__Error');
            if (existing) {
                existing.remove();
            }
            const errorElement = document.createElement('span');
            errorElement.className = 'ProductForm__Error Alert Alert--error';
            errorElement.textContent = message;
            button.insertAdjacentElement('afterend', errorElement);
            setTimeout(() => errorElement.remove(), 3000);
        }
    }
    customElements.define('fit-add-to-cart', FitAddToCart);
}
